import React, { Component } from 'react';
import VerifyPinModal from '../settings/modals/VerifyPinModal';
import ResetPinModal from '../settings/modals/ResetPinModal';
import toast from '../shared/Toast';
import { ExitReceptionModeIcon } from '../../assets/SVG';
import axios from 'axios';
import config from '../../config/API';
import { getState, ensure, subscribe, unlock, errorText } from '../../_utils/receptionMode';

/**
 * "Exit Reception Mode" in the side nav: shown while THIS device is locked;
 * unlocks it with the PIN (the server checks it, counts wrong tries and locks
 * out after five). Forgotten PIN: reset with the account password.
 */
class ReceptionModeIcon extends Component {
    constructor(props) {
        super(props);
        this.state = { locked: getState().enabled, modal: null, busy: false };
    }

    componentDidMount() {
        this.mounted = true;
        this.unsubscribe = subscribe(() => this.mounted && this.setState({ locked: getState().enabled }));
        ensure().then((s) => this.mounted && this.setState({ locked: s.enabled }));
    }

    componentWillUnmount() {
        this.mounted = false;
        if (this.unsubscribe) this.unsubscribe();
    }

    open = (e) => {
        if (e) e.preventDefault();
        // Close the sidebar so the modal isn't hidden behind it
        document.body.classList.remove('nav_menu_open');
        this.setState({ modal: 'pin' });
    }

    handleUnlock = (pin) => {
        if (this.state.busy) return;
        this.setState({ busy: true });
        unlock(pin)
            .then(() => {
                toast.success('Reception mode is off on this device');
                this.setState({ modal: null, busy: false });
                setTimeout(() => window.location.reload(), 100);
            })
            .catch((err) => {
                this.setState({ busy: false });
                toast.error(errorText(err, "That PIN isn't right"));
            });
    }

    handleReset = ({ password, pin }) => {
        return axios.post(config.RECEPTION_MODE_RESET_PIN, { password, pin, confirmPin: pin }, {
            headers: { 'Content-Type': 'application/json', authorization: 'Basic YmV1YXBwOmJldWFwcA==', accessToken: localStorage.getItem('accessToken') }
        }).then((res) => {
            if (!res.data || res.data.statusCode !== 1) throw new Error(errorText(res.data, "That didn't work"));
            toast.success('PIN reset. Enter the new PIN to unlock.');
            this.setState({ modal: 'pin' });
        }).catch((err) => { throw new Error(errorText(err, "That didn't work")); });
    }

    render() {
        const { locked, modal } = this.state;
        if (!locked) return null;
        return (
            <>
                <li>
                    <a href="#" onClick={this.open} title="Exit Reception Mode">
                        <span className="menu_icon reception-mode-active">
                            <ExitReceptionModeIcon />
                        </span>
                        <span className="sidenav_text">Exit Reception Mode</span>
                    </a>
                </li>

                {modal === 'pin' && (
                    <VerifyPinModal
                        onClose={() => this.setState({ modal: null })}
                        onVerifyPin={this.handleUnlock}
                        onForgotPin={() => this.setState({ modal: 'reset' })}
                        title="Exit Reception Mode"
                        message="Enter the reception mode PIN to unlock this device. Other devices are not affected."
                    />
                )}
                {modal === 'reset' && (
                    <ResetPinModal onClose={() => this.setState({ modal: null })} onSubmit={this.handleReset} />
                )}
            </>
        );
    }
}

export default ReceptionModeIcon;
